var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentsZeroState = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 61,
    viewBox: "0 0 86 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1603_10784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6157 60.1001C13.4593 60.1001 13.3242 60 13.2816 59.8426L0.0142671 11.465C-0.00706292 11.372 4.70991e-05 11.2791 0.0498172 11.2004C0.0924773 11.1217 0.170687 11.0573 0.263118 11.0359L39.7735 0.114432C39.8659 0.0929754 39.9583 0.100128 40.0365 0.150193C40.1148 0.193107 40.1788 0.271781 40.2001 0.36476L43.7764 13.4605C43.8262 13.6464 43.7195 13.8395 43.5347 13.8896C43.3498 13.9397 43.1578 13.8324 43.1081 13.6464L39.6242 0.87972L20.2032 6.24746L0.782149 11.6152L13.8646 59.3134L52.6426 48.5636L50.5309 40.8177C50.4812 40.6318 50.5878 40.4387 50.7727 40.3886C50.9575 40.3385 51.1495 40.4458 51.1993 40.6318L53.4034 48.7138C53.4532 48.8997 53.3465 49.0929 53.1616 49.1429L13.7082 60.0787C13.7082 60.0787 13.6442 60.093 13.6157 60.093V60.1001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1532 11.7511C27.1034 11.7511 27.0536 11.7153 27.0394 11.6653C27.0252 11.6009 27.0607 11.5365 27.1176 11.5222L34.32 9.53392C34.384 9.51961 34.448 9.55537 34.4622 9.61259C34.4765 9.67696 34.4409 9.74133 34.384 9.75564L27.1816 11.744C27.1816 11.744 27.1603 11.744 27.1532 11.744V11.7511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8068 14.8407C24.7571 14.8407 24.7073 14.8049 24.6931 14.7549C24.6789 14.6905 24.7144 14.6261 24.7713 14.6118L34.9386 11.801C35.0026 11.7867 35.0666 11.8225 35.0808 11.8797C35.095 11.944 35.0595 12.0084 35.0026 12.0227L24.8353 14.8335C24.8353 14.8335 24.8139 14.8335 24.8068 14.8335V14.8407Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7198 28.9735C12.67 28.9735 12.6203 28.9377 12.606 28.8876C12.5918 28.8233 12.6274 28.7589 12.6843 28.7446L34.8533 22.6223C34.9173 22.608 34.9813 22.6438 34.9955 22.701C35.0097 22.7653 34.9742 22.8297 34.9173 22.844L12.7482 28.9663C12.7482 28.9663 12.7269 28.9663 12.7198 28.9663V28.9735Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8386 36.283C14.7888 36.283 14.739 36.2472 14.7248 36.1972C14.7106 36.1328 14.7461 36.0684 14.803 36.0541L33.4313 30.9045C33.4953 30.8902 33.5592 30.926 33.5735 30.9832C33.5877 31.0476 33.5521 31.1119 33.4953 31.1262L14.867 36.2758C14.867 36.2758 14.8457 36.2758 14.8386 36.2758V36.283Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7725 43.8073C16.7228 43.8073 16.673 43.7715 16.6588 43.7215C16.6446 43.6571 16.6801 43.5927 16.737 43.5784L36.6521 38.0783C36.7161 38.064 36.7801 38.0998 36.7943 38.157C36.8086 38.2214 36.773 38.2858 36.7161 38.3001L16.8081 43.8001C16.8081 43.8001 16.7868 43.8001 16.7796 43.8001L16.7725 43.8073Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.9597 18.6728L77.2075 45.5711L43.953 44.2405L39.9254 18.5659L84.9597 18.6728Z",
    fill: "#FFD110",
    stroke: "#00142D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4213 5.85352L76.8867 45.7613L41.2857 45.6722L41.1431 5.85352H77.4213Z",
    fill: "white",
    stroke: "#00142D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9998 21.9998H56.5942C56.5407 21.9998 56.4932 21.9523 56.4932 21.8988C56.4932 21.8454 56.5407 21.7979 56.5942 21.7979H70.9998C71.0532 21.7979 71.1007 21.8454 71.1007 21.8988C71.1007 21.9523 71.0532 21.9998 70.9998 21.9998Z",
    fill: "black",
    stroke: "#00142D",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9997 28.1419H58.3228C58.2694 28.1419 58.2219 28.0944 58.2219 28.0409C58.2219 27.9875 58.2694 27.9399 58.3228 27.9399H70.9997C71.0532 27.9399 71.1007 27.9875 71.1007 28.0409C71.1007 28.0944 71.0532 28.1419 70.9997 28.1419Z",
    fill: "black",
    stroke: "#00142D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.306 12.6419L45.1589 12.4884L44.9464 12.4879L29.5903 12.4463L28.9761 12.4446L29.0991 13.0464L35.788 45.7663L35.8696 46.1652L36.2767 46.1662L76.8855 46.2612L77.4994 46.2627L77.3766 45.6612L71.7985 18.353L71.7157 17.9478L71.3022 17.9531L50.6506 18.2176L45.306 12.6419Z",
    fill: "white",
    stroke: "#00142D",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2156 12.4891H49.9884C49.935 12.4891 49.8875 12.4416 49.8875 12.3881C49.8875 12.3346 49.935 12.2871 49.9884 12.2871H70.2156C70.2691 12.2871 70.3166 12.3346 70.3166 12.3881C70.3166 12.4416 70.2691 12.4891 70.2156 12.4891Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2156 15.578H59.2793C59.2258 15.578 59.1783 15.5304 59.1783 15.477C59.1783 15.4235 59.2258 15.376 59.2793 15.376H70.2156C70.2691 15.376 70.3166 15.4235 70.3166 15.477C70.3166 15.5304 70.2691 15.578 70.2156 15.578Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1603_10784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.4247,
    height: 60,
    fill: "white",
    transform: "translate(0 0.100098)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentsZeroState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/documents_zeroState.1681f7cae82ddf83edf5d5fc247265c7.svg";